/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AnswerIcon = ({ width = 24, height = 24, hidden = false, title = 'Answer' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 2H3a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h11l3.536 6.839a.5.5 0 0 0 .928 0L22 28h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1ZM15.534 5.575a.306.306 0 0 1 .189-.336A7.962 7.962 0 0 1 18 4.873a9.1 9.1 0 0 1 2.311.274.366.366 0 0 1 .227.336v2.2c0 2.567-.643 9.216-.756 10.133 0 .092-.04.184-.266.184h-3.035a.24.24 0 0 1-.265-.184c-.075-.855-.682-7.475-.682-10.041ZM18 24.729a2.519 2.519 0 0 1-2.7-2.661 2.624 2.624 0 0 1 2.7-2.739 2.582 2.582 0 0 1 2.7 2.739 2.52 2.52 0 0 1-2.7 2.661Z"
    />
  </svg>`;
};
